import 'whatwg-fetch'
import m from 'mithril'
import i from 'icepick'
import promiseFinally from 'promise.prototype.finally'
import { globalClasses } from 'styles'
promiseFinally.shim()

global.isDev = process.env.NODE_ENV !== 'production'
global.i = i
global.m = m
global.globalClasses = globalClasses

global.Loading = 'div' // TODO
